import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogConfirm, DialogConfirmData } from 'app/dialogs/confirm/dialog-confirm';
import { ExposedListPensionBenefitAcquisitionCoefficientRes } from 'app/interfaces/responses/Exposed/exposedListPensionBenefitAcquisitionCoefficientRes';
import { PensionService } from 'app/services/api/pension/pension.service';
import { TranslationService } from 'app/services/api/translation/translation.service';

@Component({
    selector: 'pension-coefficients-acquisition',
    templateUrl: './pension-coefficients-acquisition.component.html',
})
export class PensionCoefficientsAcquisitionComponent implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
    protected response: ExposedListPensionBenefitAcquisitionCoefficientRes[];
    protected dataSource: MatTableDataSource<any>;
    protected tableColumns: string[] = ['fund', 'age', 'acquisitionType', 'acquisitionCoefficient'];

    constructor(
        private pensionService: PensionService,
        public dialog: MatDialog,
        private translationService: TranslationService
    ) {}

    ngOnInit(): void {
        this.refresh();
    }

    refresh(): void {
        this.pensionService.getPensionBenefitAcquisitionCoefficients().then((res) => {
            this.response = res;

            this.dataSource = new MatTableDataSource(this.response);
            this.dataSource.sort = this.sort;
        });
    }

    updateAcquisitionCoefficients = () => {
        const dialogRef = this.dialog.open(DialogConfirm, {
            autoFocus: false,
            restoreFocus: false,
            width: '450px',
            disableClose: true,
            data: {
                title: this.translationService.translate('label_confirm_action'),
                message: this.translationService.translate('info_data_will_be_synced_with_kria_db'),
            } as DialogConfirmData,
        });

        dialogRef.afterClosed().subscribe((confirm: boolean) => {
            if (confirm) {
                this.pensionService.updatePensionBenefitAcquisitionCoefficients().subscribe({
                    next: () => {
                        this.refresh();
                    },
                });
            }
        });
    };
}
